import { I18NText } from '../core/api/model/i18NText';

export class InspectionListItemDto {
  public inspectionKey!: string;
  public isSelected = false;
  public isSelectable: boolean = true;
  public isReadyForUpload = false;
  public name?: string | null;
  public address?: string | null;
  public postalZone?: string | null;
  public town?: string | null;
  public inspectionType?: I18NText;
  public inspectionDate!: Date;
  public inspectionStatus?: I18NText;
  public tvdNumber?: string | null;
  public burNumber?: string | null;
  public cantonId?: string | null;
  public categoryShortNames?: I18NText[];
  public inspectorName?: string | null;
  public inspectionStyleName?: string;
  public isActive: boolean = true;
}
